__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "payments-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.11.5", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(335), __webpack_require__.e(995), __webpack_require__.e(991)]).then(() => (() => (__webpack_require__(65335))))));
			register("@payconstruct/design-system", "5.0.15", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(681), __webpack_require__.e(995), __webpack_require__.e(717)]).then(() => (() => (__webpack_require__(95681))))));
			register("@payconstruct/fe-utils", "2.0.10", () => (Promise.all([__webpack_require__.e(75), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(69075))))));
			register("@payconstruct/orbital-auth-provider", "3.1.0", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(965), __webpack_require__.e(995), __webpack_require__.e(604)]).then(() => (() => (__webpack_require__(15965))))));
			register("antd", "5.22.2", () => (Promise.all([__webpack_require__.e(95), __webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(66), __webpack_require__.e(278)]).then(() => (() => (__webpack_require__(40095))))));
			register("aws-appsync-auth-link", "3.0.7", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(835), __webpack_require__.e(295), __webpack_require__.e(991), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(8295))))));
			register("aws-appsync-subscription-link", "3.1.3", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(835), __webpack_require__.e(774), __webpack_require__.e(991), __webpack_require__.e(79), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(42774))))));
			register("copy-to-clipboard", "3.3.3", () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(17965))))));
			register("encrypt-storage", "2.13.03", () => (__webpack_require__.e(343).then(() => (() => (__webpack_require__(75343))))));
			register("graphql", "16.9.0", () => (__webpack_require__.e(942).then(() => (() => (__webpack_require__(23942))))));
			register("moment-timezone", "0.5.45", () => (Promise.all([__webpack_require__.e(29), __webpack_require__.e(743), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(84743))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-error-boundary", "3.1.4", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(740)]).then(() => (() => (__webpack_require__(24740))))));
			register("react-intl", "6.6.8", () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(66363))))));
			register("react-router-dom", "6.4.5", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "17.0.2", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(10096);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};